module.exports = __webpack_public_path__ + "media/src/images/icons/add/user-primary-bc1b67ce2de39fa7b5eff12a4a7ec8f7.svg";